function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M491.122 885.712l-38.22 62.227c-2.416 3.934-5.454 7.449-8.996 10.409-38.859 32.474-98.216 30.691-134.754-4.238-19.226-18.38-29.51-43.719-27.956-67.22l-0.076-164.194-187.713-152.661c-18.514-15.057-32.788-34.669-41.414-56.908-27.461-70.798 7.783-150.393 78.658-177.771l749.728-289.603c14.515-5.607 28.202-3.135 38.661 3.87 12.995 8.322 20.623 23.226 19.55 38.817-0.184 2.978-0.7 5.971-1.578 8.933l-204.437 736.511c-20.172 72.673-95.798 115.25-168.882 95.401-18.412-5.001-35.579-13.752-50.404-25.703l-22.167-17.869zM424.142 831.718l-57.697-46.511 0.002 104.327c-0.042 0.668 0.348 1.628 1.672 2.894 4.004 3.828 11.387 4.814 17.070 2.711l38.953-63.421zM388.906 693.705l177.938 143.441c5.633 4.541 12.177 7.877 19.215 9.788 27.953 7.592 56.722-8.606 64.291-35.874l157.826-568.59-419.271 451.235zM319.125 643.557l419.715-451.57-577.421 222.975c-26.914 10.393-40.258 40.519-29.867 67.299 3.267 8.42 8.678 15.852 15.703 21.564l171.871 139.733z"
});

var SvgSent = function SvgSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sent.3e1ad9e4.svg";
export { ForwardRef as ReactComponent };